class WorkbookTabDataSourceVM {
    id: number; //used in keyExpr
    iconClass: string;
    title: string;
    visible: KnockoutComputed<boolean>;
    tab: KnockoutObservable<WorkbookTab>;
    /**For the dropdown selection */
    selected: boolean = false;

    constructor(data) {
        this.iconClass = data.iconClass;
        this.title = data.title;
        this.tab = ko.observable(data.tab);
        this.id = this.tab().id();
        this.visible = ko.computed(function (this: WorkbookTabDataSourceVM) {
            return this.tab().workbookConfig.generalSettings.editing() || this.tab().detailingWidget.hasDetailing() ? true : !this.tab().tabConfig.hiddenTab()
        }, this);

        this.template = this.template.bind(this);
    }

    get tabId() {
        return this.tab().id();
    }

    template() {
        return workbook.workbookConfig.workbookHelper.getTab(this.tab());
    }

    get dxContextMenu(): DevExpress.ui.dxContextMenu {
        let contextMenu = $(`#tab-contextMenu-${this.tabId}`).data("dxContextMenu");
        return contextMenu;
    }
}